const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Compact timestamp for a list row, in the style mail clients use: a time
 * today, a weekday this week, a date beyond that. The full timestamp is on the
 * element's `title`, so nothing is actually lost by shortening it.
 */
export function relativeTime(epochMs: number, now = Date.now()): string {
  const elapsed = now - epochMs;

  if (elapsed < MINUTE) return 'now';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}m`;

  const date = new Date(epochMs);

  if (elapsed < DAY && date.getDate() === new Date(now).getDate()) {
    return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  }

  if (elapsed < 7 * DAY) return date.toLocaleDateString(undefined, { weekday: 'short' });

  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

/** Full timestamp for tooltips and the reader header. */
export function fullTime(epochMs: number): string {
  return new Date(epochMs).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

/** Byte count in the shortest unit that keeps it under four digits. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
